import * as React from "react";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Row, Col } from "common/components/layout-styles";
import { useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import { MarkdownPreview } from "components/common/MarkdownEditor";
import { Alert } from "components/bootstrap";
const SectionHeaderRow = styled(Row)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.input.border};
  padding-bottom: ${({ theme }) => theme.spacings.sm};
`;
function useTableElements(selectedSteps) {
  const { t } = useTranslation("enterprise_security_events");
  const selectedRows = useSelectedRows();
  const selectedRowsDispatch = useSelectedRowsDispatch();
  const renderExpanded = useCallback(
    (step) => /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(SectionHeaderRow, null, /* @__PURE__ */ React.createElement("h5", null, t("table_elements.description"))), (step == null ? void 0 : step.description) ? /* @__PURE__ */ React.createElement(MarkdownPreview, { show: true, maxHeight: 400, noBackground: true, noBorder: true, value: step == null ? void 0 : step.description, noPadding: true }) : /* @__PURE__ */ React.createElement(Alert, { style: { width: "100%" } }, t("table_elements.no_description"))),
    [t]
  );
  const expandedSections = useMemo(
    () => ({
      restFieldsExpandedSection: {
        title: null,
        content: renderExpanded
      }
    }),
    [renderExpanded]
  );
  const bulkSelection = useMemo(
    () => ({
      onChangeSelection: (stepIds, list) => {
        const currentSteps = [...selectedSteps, ...selectedRows, ...list].reduce(
          (acc, step) => {
            if (!acc.find((s) => s.id === step.id)) acc.push(step);
            return acc;
          },
          []
        );
        const auxSelectedSteps = stepIds.length > 0 ? stepIds.map(
          (stepId) => currentSteps.find((step) => step.id === stepId)
        ) : [];
        selectedRowsDispatch({ type: "upsert", payload: auxSelectedSteps });
      },
      actions: /* @__PURE__ */ React.createElement("div", null),
      initialSelection: selectedSteps == null ? void 0 : selectedSteps.map((step) => step.id)
    }),
    [selectedRowsDispatch, selectedSteps, selectedRows]
  );
  return {
    expandedSections,
    bulkSelection
  };
}
export default useTableElements;
